import Firebase from '../modules/firebase'
import ENUM from '../assets/ENUM'

export default {

    getInPercentage: async function (testName) {
        // the default version is A
        const percent = await Firebase
            .getValue(testName, Firebase.TYPES.NUMBER)
            .then(value => {
                return (typeof value !== 'number' || value > 100 || value < 0)
                    ? 0
                    : value
            })
        const random = Math.floor(Math.random() * (100 + 1) + 0)

        return (random >= percent)
            ? ENUM.abTest.A
            : ENUM.abTest.B
    }
}